export let LivesitePageLoadModeType = /*#__PURE__*/function (LivesitePageLoadModeType) {
  LivesitePageLoadModeType["LIVE_SITE"] = "live site";
  LivesitePageLoadModeType["PREVIEW"] = "preview";
  return LivesitePageLoadModeType;
}({});
export let LivesitePageLoadStatusDisplayedType = /*#__PURE__*/function (LivesitePageLoadStatusDisplayedType) {
  LivesitePageLoadStatusDisplayedType["ACCEPTING_ORDERS"] = "accepting_orders";
  LivesitePageLoadStatusDisplayedType["CLOSED"] = "closed";
  LivesitePageLoadStatusDisplayedType["TEMPORARY_CLOSED"] = "temporary closed";
  LivesitePageLoadStatusDisplayedType["OPENNING_SOON"] = "opening soon";
  LivesitePageLoadStatusDisplayedType["CLOSING_SOON"] = "closing soon";
  return LivesitePageLoadStatusDisplayedType;
}({});
//# sourceMappingURL=constants.js.map